export default class Accordion {
  constructor(el){
    this.element = $(el);
    this.btn = this.element.find('.js-accordion-btn');
    this.body = this.element.find('.js-accordion-body');
    this.openClass = 'is-open';
    this.event();
  }

  event(){
    this.btn.on('click', e => {
      e.preventDefault();
      let isOpen = this.element.hasClass(this.openClass);
      if(isOpen){
        this.close();
      }else{
        this.open();
      }
    });
  }

  open(){
    this.element.addClass(this.openClass);
  }

  close(){
    this.element.removeClass(this.openClass);
  }
}




// WEBPACK FOOTER //
// ./js/_modules/_accordion.js